import { render, staticRenderFns } from "./FmaHeader.vue?vue&type=template&id=65b2cf20&scoped=true"
import script from "./FmaHeader.vue?vue&type=script&lang=js"
export * from "./FmaHeader.vue?vue&type=script&lang=js"
import style0 from "./FmaHeader.vue?vue&type=style&index=0&id=65b2cf20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b2cf20",
  null
  
)

export default component.exports